const styles = {
    postContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxHeight: 'auto'
    },
    popUpOverlay: {
        width: '100vw',
        height: '100vh',
        // top: '0px',
        // left: '0px',
        // position: 'fixed',
        zIndex: 1200,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '0px !important' //not a fan of !important but keeps being overidden by mui5 stack somewhere in their module
    },
    popUpBox: {
        zIndex: 1200,
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: '#00000094',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}

export default styles; 